import React, {Component} from "react"
import { Entity } from "aframe-react"


class FadeAnimation extends Component {

    render() {
        return (
            <a-animation

                id={this.props.id}

                attribute={this.props.attribute}

                dur={this.props.dur}

                from={ (!this.props.reverse) ? this.props.min : this.props.max }
                to={ !(this.props.reverse) ? this.props.max : this.props.min }

                begin={ !(this.props.reverse) ? this.props.begin : this.props.end }
                end={ !(this.props.reverse) ? this.props.end : this.props.begin }

            />
        )
    }
}

FadeAnimation.defaultProps = {
    reverse: false,

    attribute: "material.opacity",

    dur: 100,

    min: 0.1,
    max: 1.0,

    begin: "mouseenter",
    end: "mouseleave"
}

export default FadeAnimation


// WEBPACK FOOTER //
// ./src/components/FadeAnimation.js